





































import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "../styles/WestEastBound.css";
import scheduleIcon from "../assets/icons/schedule-icon.png"; // Make sure to have this icon
// Updated import path to match your actual file structure
import ScheduleImage from "../image/Schedule-image.png";

const WestEastBound = () => {
  const navigate = useNavigate();
  const [scheduleData, setScheduleData] = useState({
    importRoute: null,
    exportRoute: null,
    importData: null,
    exportData: null
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [activeTab, setActiveTab] = useState("import"); // "import" or "export"
  const [hoveredCell, setHoveredCell] = useState({ row: null, col: null });
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
  const tableRef = useRef(null);

  useEffect(() => {
    fetchScheduleData();
    
    // Check if user is logged in as admin
    const adminStatus = sessionStorage.getItem('isAdmin');
    if (adminStatus === 'true') {
      setIsAdmin(true);
    }
  }, []);

  const fetchScheduleData = async () => {
    try {
      setLoading(true);
      
      // Get routes data
      const routesResponse = await axios.get('https://ecl.net.in/backende/api/sailing-routes');
      const routes = routesResponse.data;
      
      // Find import and export routes
      const importRoute = routes.find(r => 
        r.direction.toUpperCase().includes('IMPORT') && 
        !r.direction.toUpperCase().includes('EXPORT')
      );
      
      const exportRoute = routes.find(r => 
        r.direction.toUpperCase().includes('EXPORT') && 
        !r.direction.toUpperCase().includes('IMPORT')
      );
      
      // Get schedules for import route
      let importData = null;
      if (importRoute) {
        const importResponse = await axios.get(`https://ecl.net.in/backende/api/sailing-schedule/${importRoute.id}`);
        importData = importResponse.data;
      }
      
      // Get schedules for export route
      let exportData = null;
      if (exportRoute) {
        const exportResponse = await axios.get(`https://ecl.net.in/backende/api/sailing-schedule/${exportRoute.id}`);
        exportData = exportResponse.data;
      }
      
      setScheduleData({
        importRoute: importRoute,
        exportRoute: exportRoute,
        importData: importData,
        exportData: exportData
      });
      
      setLoading(false);
    } catch (err) {
      setError("Failed to load schedule data.");
      setLoading(false);
      console.error("Error fetching schedule data:", err);
    }
  };

  const handleLogout = () => {
    sessionStorage.removeItem('isAdmin');
    setIsAdmin(false);
  };

  const handleEditSchedule = () => {
    navigate('/admin/schedule');
  };

  // Helper function to get schedule for a specific vessel and port
  const getScheduleDate = (vesselId, portId, data) => {
    if (!data || !data.schedules) return "";
    
    const schedule = data.schedules.find(
      s => s.vessel_id === vesselId && s.port_id === portId
    );
    
    return schedule ? schedule.dates : "";
  };

  // Helper function to get ETA/ETD for a specific vessel and port
  const getScheduleTimes = (vesselId, portId, data) => {
    if (!data || !data.schedules) return { eta: "", etd: "" };
    
    const schedule = data.schedules.find(
      s => s.vessel_id === vesselId && s.port_id === portId
    );
    
    return {
      eta: schedule?.eta || "",
      etd: schedule?.etd || ""
    };
  };

  // Handle cell hover to show row and column names
  const handleCellHover = (e, rowIndex, colIndex) => {
    // Get mouse position relative to viewport
    const x = e.clientX;
    const y = e.clientY;
    
    setHoveredCell({ row: rowIndex, col: colIndex });
    setTooltipPosition({ x, y });
  };

  const handleCellLeave = () => {
    setHoveredCell({ row: null, col: null });
  };

  // Render tooltip for vessels and ports
  const renderTooltip = () => {
    if (hoveredCell.row === null && hoveredCell.col === null) return null;
    
    const data = activeTab === "import" ? scheduleData.importData : scheduleData.exportData;
    if (!data || !data.vessels || !data.ports) return null;
    
    // Get vessel and port data
    const vessel = hoveredCell.col !== null && hoveredCell.col < data.vessels.length
      ? data.vessels[hoveredCell.col]
      : null;
    
    const port = hoveredCell.row !== null && hoveredCell.row < data.ports.length
      ? data.ports[hoveredCell.row]
      : null;
    
    if (!vessel && !port) return null;

    // Calculate tooltip position to ensure it stays in viewport
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;
    const tooltipWidth = 250; // Approximate width of tooltip
    const tooltipHeight = 150; // Approximate height of tooltip
    
    let x = tooltipPosition.x + 20; // Add some offset from cursor
    let y = tooltipPosition.y + 20;
    
    // Adjust if tooltip would go off the right side
    if (x + tooltipWidth > viewportWidth) {
      x = tooltipPosition.x - tooltipWidth - 10;
    }
    
    // Adjust if tooltip would go off the bottom
    if (y + tooltipHeight > viewportHeight) {
      y = tooltipPosition.y - tooltipHeight - 10;
    }

    const tooltipStyle = {
      top: y + 'px',
      left: x + 'px',
      position: 'fixed', // Use fixed positioning relative to viewport
      zIndex: 9999
    };

    // Determine if we're showing vessel or port info or both
    let tooltipContent = null;
    
    if (vessel && port) {
      // Both vessel and port are hovered - show schedule details
      const scheduleDate = getScheduleDate(vessel.id, port.id, data);
      const { eta, etd } = getScheduleTimes(vessel.id, port.id, data);
      
      tooltipContent = (
        <>
          <div className="tooltip-header">
            <span className="tooltip-category">Schedule Details</span>
          </div>
          <div className="tooltip-content">
            <div className="tooltip-row">
              <span className="tooltip-label">Vessel:</span>
              <span className="tooltip-value">{vessel.name}</span>
            </div>
            <div className="tooltip-row">
              <span className="tooltip-label">Port:</span>
              <span className="tooltip-value">{port.name}</span>
            </div>
            {scheduleDate && (
              <div className="tooltip-row">
                <span className="tooltip-label">Date:</span>
                <span className="tooltip-value">{scheduleDate}</span>
              </div>
            )}
            {eta && (
              <div className="tooltip-row">
                <span className="tooltip-label">ETA:</span>
                <span className="tooltip-value">{eta}</span>
              </div>
            )}
            {etd && (
              <div className="tooltip-row">
                <span className="tooltip-label">ETD:</span>
                <span className="tooltip-value">{etd}</span>
              </div>
            )}
          </div>
        </>
      );
    } else if (vessel) {
      // Only vessel is hovered
      tooltipContent = (
        <>
          <div className="tooltip-header">
            <span className="tooltip-category">Vessel Details</span>
          </div>
          <div className="tooltip-content">
            <div className="tooltip-row">
              <span className="tooltip-label">Name:</span>
              <span className="tooltip-value">{vessel.name}</span>
            </div>
            {vessel.type && (
              <div className="tooltip-row">
                <span className="tooltip-label">Type:</span>
                <span className="tooltip-value">{vessel.type}</span>
              </div>
            )}
            {vessel.capacity && (
              <div className="tooltip-row">
                <span className="tooltip-label">Capacity:</span>
                <span className="tooltip-value">{vessel.capacity}</span>
              </div>
            )}
          </div>
        </>
      );
    } else if (port) {
      // Only port is hovered
      tooltipContent = (
        <>
          <div className="tooltip-header">
            <span className="tooltip-category">Port Details</span>
          </div>
          <div className="tooltip-content">
            <div className="tooltip-row">
              <span className="tooltip-label">Name:</span>
              <span className="tooltip-value">{port.name}</span>
            </div>
            {port.country && (
              <div className="tooltip-row">
                <span className="tooltip-label">Country:</span>
                <span className="tooltip-value">{port.country}</span>
              </div>
            )}
            {port.code && (
              <div className="tooltip-row">
                <span className="tooltip-label">Code:</span>
                <span className="tooltip-value">{port.code}</span>
              </div>
            )}
          </div>
        </>
      );
    }

    return (
      <div className="schedule-tooltip" style={tooltipStyle}>
        {tooltipContent}
      </div>
    );
  };

  // Render the active tab's schedule table
  const renderScheduleTable = () => {
    const data = activeTab === "import" ? scheduleData.importData : scheduleData.exportData;
    
    if (!data || !data.vessels || !data.ports) {
      return <div className="schedule-no-data">No schedule data available</div>;
    }

    return (
      <div className="schedule-table-wrapper">
        <div className="schedule-direction">
          {data.route.direction}
        </div>
        
        <div className="schedule-table-container" ref={tableRef}>
          {/* Tooltip for hover */}
          {renderTooltip()}
          
          <table className="schedule-table">
            <thead>
              <tr className="schedule-header-row">
                <th className="schedule-header-cell">VESSEL</th>
                {data.vessels.map((vessel, index) => (
                  <th 
                    key={vessel.id} 
                    className="schedule-header-cell vessel-name-cell"
                    onMouseEnter={(e) => handleCellHover(e, null, index)}
                    onMouseLeave={handleCellLeave}
                  >
                    {vessel.name}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              <tr className="schedule-port-header-row">
                <th className="schedule-header-cell">PORT</th>
                {data.vessels.map((vessel, index) => (
                  <th 
                    key={`port-header-${vessel.id}`} 
                    className="schedule-empty-cell"
                    onMouseEnter={(e) => handleCellHover(e, null, index)}
                    onMouseLeave={handleCellLeave}
                  ></th>
                ))}
              </tr>
              
              {data.ports.map((port, rowIndex) => (
                <tr 
                  key={port.id} 
                  className="schedule-table-row"
                >
                  <td 
                    className="schedule-header-cell port-name-cell"
                    onMouseEnter={(e) => handleCellHover(e, rowIndex, null)}
                    onMouseLeave={handleCellLeave}
                  >
                    {port.name}
                    {port.country && <span className="port-country">{port.country}</span>}
                  </td>
                  {data.vessels.map((vessel, colIndex) => {
                    const scheduleDate = getScheduleDate(vessel.id, port.id, data);
                    const { eta, etd } = getScheduleTimes(vessel.id, port.id, data);
                    
                    return (
                      <td 
                        key={`${vessel.id}-${port.id}`} 
                        className={`schedule-data-cell ${scheduleDate ? 'schedule-date-cell' : 'schedule-empty-cell'}`}
                        onMouseEnter={(e) => handleCellHover(e, rowIndex, colIndex)}
                        onMouseLeave={handleCellLeave}
                        data-vessel={vessel.name}
                        data-port={port.name}
                      >
                        {scheduleDate && (
                          <>
                            <div className="schedule-date">{scheduleDate}</div>
                            {eta && <div className="schedule-eta">ETA: {eta}</div>}
                            {etd && <div className="schedule-etd">ETD: {etd}</div>}
                          </>
                        )}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  return (
    <div className="schedule-container">
      {/* Image Slider */}
      <div className="schedule-image-slider">
        <img src={ScheduleImage} alt="Sailing Schedule" />
      </div>
      
      {/* Main Content Container */}
      <div className="schedule-content">
        {/* Schedule Card */}
        <div className="schedule-card">
          {/* Wheel icon and title */}
          <div className="schedule-header-container">
            <img src={scheduleIcon} alt="Schedule" className="schedule-wheel-icon" />
            <div className="schedule-header-title">Sailing Schedule</div>
            
            {/* Show admin controls only if logged in */}
            {isAdmin && (
              <div className="schedule-admin-controls">
                <span className="schedule-admin-welcome">Welcome, Admin</span>
                <button 
                  className="schedule-edit-btn" 
                  onClick={handleEditSchedule}
                >
                  Edit Schedule
                </button>
                <button 
                  className="schedule-logout-btn" 
                  onClick={handleLogout}
                >
                  Logout
                </button>
              </div>
            )}
          </div>
          
          <div className="schedule-tabs-container">
            <button 
              className={`schedule-tab-btn ${activeTab === 'import' ? 'active' : ''}`}
              onClick={() => setActiveTab('import')}
            >
              Import Schedule
            </button>
            <button 
              className={`schedule-tab-btn ${activeTab === 'export' ? 'active' : ''}`}
              onClick={() => setActiveTab('export')}
            >
              Export Schedule
            </button>
          </div>
          
          <div className="schedule-data-content">
            {loading ? (
              <div className="schedule-loading">
                <div className="schedule-spinner"></div>
                <div>Loading schedule data...</div>
              </div>
            ) : error ? (
              <div className="schedule-error">{error}</div>
            ) : (
              renderScheduleTable()
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WestEastBound;